export default __webpack_public_path__ + "static/media/noEnviado.904a7ab8.svg";